<template>
  <component
    :is="hComponent"
    v-if='raw'
  >
    <slot />
  </component>
  <w-row v-else-if='onlyColumn === false'>
    <w-column class='pb-0'>
      <component :is="hComponent">
        <slot />
      </component>
    </w-column>
  </w-row>
  <w-column
    v-else
    cols='12'
    class='pb-0'
  >
    <component :is="hComponent">
      <slot />
    </component>
  </w-column>
</template>

<script>
export default {
  name: 'WorkInlineTitle',
  props: {
    raw: { type: Boolean, default: false },
    onlyColumn: { type: Boolean, default: false },
    hComponent: { type: String, default: 'h5' }
  },
};
</script>
